import React, { useEffect, useState } from 'react'
import {
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import FantasyRoundEmailLog from './FantasyRoundEmailLog'
import EmailQuotaService from 'src/service/EmailQuotaService'
import SentMemberEmailLog from './SentMemberEmailLog'
import EmailQuotaDetails from '../EmailAlerts/EmailQuotaDetails'

const EmailTrack = () => {
  const [alertCount, setAlertCount] = useState(24)
  useEffect(() => {
    EmailQuotaService.getEmailAlertCount().then((res) => {
      if (res.status === 200) {
        setAlertCount(res.data)
      }
    })
  }, [])
  return (
    <>
      <EmailQuotaDetails />
      <CRow>
        <CAccordion>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>Fantasy Round Reminder - {alertCount?.fantasyRoundReminderCount}</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <FantasyRoundEmailLog emailType={1} />
            </CAccordionBody>
          </CAccordionItem>
          <CAccordionItem itemKey={3}>
            <CAccordionHeader>
              {' '}
              <strong>Fantasy Round Results & Reminder - {alertCount?.fantasyResultCount}</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <FantasyRoundEmailLog emailType={2} />
            </CAccordionBody>
          </CAccordionItem>
          <CAccordionItem itemKey={4}>
            <CAccordionHeader>
              {' '}
              <strong>Top 10 Managers (Overall) - {alertCount?.getTopManagerCount}</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <FantasyRoundEmailLog emailType={4} />
            </CAccordionBody>
          </CAccordionItem>
          <CAccordionItem itemKey={5}>
            <CAccordionHeader>
              {' '}
              <strong>Top 10 Players (Overall) - {alertCount?.getTopPlayerCount}</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <FantasyRoundEmailLog emailType={3} />
            </CAccordionBody>
          </CAccordionItem>
          <CAccordionItem itemKey={6}>
            <CAccordionHeader>
              {' '}
              <strong>Announce Final Result - {alertCount?.finalResultCount}</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <FantasyRoundEmailLog emailType={6} />
            </CAccordionBody>
          </CAccordionItem>
          <CAccordionItem itemKey={7}>
            <CAccordionHeader>
              {' '}
              <strong>Email Members - {alertCount?.gameMemberEmailCount}</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <SentMemberEmailLog />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
    </>
  )
}

export default EmailTrack
